import { SafetySessionStorage } from '@mail-core/std/storage';
import { Icon16Cancel, Icon24ErrorCircleOutline } from '@vkontakte/icons';
import { Link, Text } from '@vkontakte/vkui';
import clsx from 'clsx';
import React, { useCallback, useEffect, useState } from 'react';
import { SHARE_SPACE_CONSUMPTION_HREF } from 'reactApp/appHelpers/featuresHelpers/features/shareSpaceConsumptionWarning';
import { sendGa } from 'reactApp/utils/ga';

import styles from './SpaceConsumptionWarning.css';

const storage = new SafetySessionStorage({});

const SPACE_CONSUMPTION_WARNING_CLOSED_KEY = 'SPACE_CONSUMPTION_WARNING_CLOSED_KEY';

const sendRadar = (action: string) => sendGa('shr-cnswrn', action);

const SpaceConsumptionWarningInner = ({ isBizVariant }: { isBizVariant?: boolean }) => {
    const [isVisible, setIsVisible] = useState(() => storage.getItem(SPACE_CONSUMPTION_WARNING_CLOSED_KEY) !== 'true');

    useEffect(() => {
        sendRadar('shw');
    }, []);

    const handleClose = useCallback(() => {
        setIsVisible(false);
        storage.setItem(SPACE_CONSUMPTION_WARNING_CLOSED_KEY, 'true');
        sendRadar('cls');
    }, []);

    const handleHelp = useCallback(() => sendRadar('hlp'), []);

    if (!isVisible) {
        return null;
    }

    return (
        <div className={clsx(styles.root, { [styles.biz]: isBizVariant })} data-qa-id="share-space-consumption-warning">
            {isBizVariant && (
                <div className={styles.infoIcon}>
                    <Icon24ErrorCircleOutline />
                </div>
            )}
            <Text>
                {isBizVariant ? (
                    <>С таким доступом папка будет занимать место в&nbsp;Диске у&nbsp;всех добавленных пользователей, кроме коллег.</>
                ) : (
                    <>
                        С таким доступом расходуется место в Облаке
                        <br /> пользователя.
                    </>
                )}
                <Link href={SHARE_SPACE_CONSUMPTION_HREF} target="_blank" onClick={handleHelp} data-qa-id="link">
                    {' '}
                    Подробнее
                </Link>
            </Text>
            <div className={styles.close} onClick={handleClose} data-qa-id="close">
                <Icon16Cancel />
            </div>
        </div>
    );
};

export const SpaceConsumptionWarning = React.memo(SpaceConsumptionWarningInner);
